'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Truncate": "Polaris-Truncate"
};

exports.default = styles;
